import _extends from "@babel/runtime/helpers/esm/extends";
export const getSchedulerLocalization = translations => ({
  components: {
    MuiEventCalendar: {
      defaultProps: {
        localeText: _extends({}, translations.dialog, translations.calendar)
      }
    },
    MuiEventTimeline: {
      defaultProps: {
        localeText: _extends({}, translations.dialog, translations.timeline)
      }
    }
  }
});